import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categories } from '@/mocks/categories';
import type { CategoryGroup } from '@/mocks/categories';

export default function Category() {
  const [activeTab, setActiveTab] = useState<string>(categories[0].id);
  const activeCategory = categories.find((c) => c.id === activeTab) || categories[0];

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <section className="w-full px-4 md:px-6 py-8 bg-background-50">
          <div className="max-w-6xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: '影视分类' },
              ]}
            />

            <div className="mt-4 mb-8">
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                影视分类
              </h1>
              <p className="text-foreground-600 text-sm">
                按类型浏览你喜欢的影视内容，发现更多精彩
              </p>
            </div>

            <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 flex-wrap">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => setActiveTab(cat.id)}
                  className={`whitespace-nowrap px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer flex items-center gap-2 ${
                    activeTab === cat.id
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  <i className={cat.icon}></i>
                  {cat.name}
                </button>
              ))}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
              {activeCategory.items.map((item) => (
                <Link
                  key={item.id}
                  to={`/article/${item.id}`}
                  className="group block cursor-pointer"
                >
                  <div className="aspect-[3/4] rounded-xl overflow-hidden bg-background-100 mb-3">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      loading="lazy"
                    />
                  </div>
                  <h3 className="font-medium text-foreground-900 text-sm text-center group-hover:text-primary-600 transition-colors duration-200 line-clamp-1">
                    {item.title}
                  </h3>
                  <div className="flex items-center justify-center gap-1 mt-1">
                    <i className="ri-star-fill text-yellow-500 text-xs"></i>
                    <span className="text-xs text-foreground-500">{item.count}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <script type="application/ld+json" dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "影视分类 - 91影视看片app",
            "description": "浏览电影、电视剧、综艺、动漫等各类影视资源分类，发现你喜欢的影视内容。",
            "url": "https://www.91yingshi.com/category",
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://www.91yingshi.com/" },
                { "@type": "ListItem", "position": 2, "name": "影视分类", "item": "https://www.91yingshi.com/category" }
              ]
            }
          })
        }} />
      </main>
      <Footer />
    </>
  );
}